import {RiotChampStats} from "../RiotDB";
import {SimStats} from "./SimStats";

export default class SimChampion extends SimStats{

	constructor(r:RiotChampStats){
		super();

		this.H = r.hp;
		this.H_PL = r.hpperlevel;
		this.MA = r.mp;
		this.MA_PL = r.mpperlevel;
		this.A = r.armor;
		this.A_PL = r.armorperlevel;
		this.MR = r.spellblock;
		this.MR_PL = r.spellblockperlevel;
		this.HR = r.hpregen;
		this.HR_PL = r.hpregenperlevel;
		this.MAR = r.mpregen;
		this.MAR_PL = r.mpregenperlevel;
		this.AD = r.attackdamage;
		this.AD_PL = r.attackdamageperlevel;
		this.C = r.crit;
		this.C_PL = r.critperlevel;

	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/calculation/SimChampion.ts